<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "drygoods",
    data() {
        return {
            params: {
                json: 0,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '实战 跨境')
        this.$store.dispatch('getText')
    }
}
</script>